import {
	FETCH_PATIENT_PROVINCE_LISTS_REQUEST,
	FETCH_PATIENT_PROVINCE_LISTS_SUCCESS,
	FETCH_PATIENT_PROVINCE_LISTS_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
};

const provinceListReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PATIENT_PROVINCE_LISTS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case FETCH_PATIENT_PROVINCE_LISTS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case FETCH_PATIENT_PROVINCE_LISTS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			}
		default:
			return state;
	}
}
export default provinceListReducer